import React from 'react';
import './AboutCard.scss';

const AboutCard = ({ image, altText, title, description, index }) => (
  <div
    className="about-card"
    data-sal="slide-up"
    data-sal-easing="ease"
    data-sal-delay={(index + 1) * 100}
  >
    <img className="about-card__img" src={image} alt={altText} width="250px" height="210px" />
    <h6>{title}</h6>
    <p className="body-2">{description}</p>
  </div>
);

export default AboutCard;
